import { render, staticRenderFns } from "./NewICD10.vue?vue&type=template&id=d01fb334&scoped=true"
import script from "./NewICD10.vue?vue&type=script&lang=js"
export * from "./NewICD10.vue?vue&type=script&lang=js"
import style0 from "./NewICD10.vue?vue&type=style&index=0&id=d01fb334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01fb334",
  null
  
)

export default component.exports